import { render } from "./UserProfile.vue?vue&type=template&id=fb720152&scoped=true"
import script from "./userprofile.view.js?vue&type=script&lang=js&external"
export * from "./userprofile.view.js?vue&type=script&lang=js&external"

import "./userprofile.css?vue&type=style&index=0&id=fb720152&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb720152"]])

export default __exports__